import CursoService from "@/api/services/cobranza/curso/CursoService"
import EstudianteService from "@/api/services/cobranza/estudiante/EstudianteService"
import Vue from "vue"

const state = () => ({
    cursos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "curso",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    CURSOS: state => {
        return state.cursos
    },
    CURSOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_CURSOS: (state, payload) => {
        state.cursos = payload
    },

    SET_CURSOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_CURSO: (state, payload) => {
        state.cursos.push(payload)
    },

    UPDATE_CURSO: (state, payload) => {
        state.cursos = state.cursos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_CURSO: (state, payload) => {
        state.cursos = state.cursos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_CURSOS: async ({ commit, state }, { estudianteId, cursoEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await CursoService.get({
                estudianteId,
                cursoEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_CURSOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los cursos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_CURSOS: async ({ commit }) => {
        try {
            let { data, status } = await CursoService.get()
            if (status === 200) {
                commit("SET_CURSOS", data)
                return null
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_CURSO_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await CursoService.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_CURSO", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles del curso, inténtelo nuevamente"
            })
        }
    },

    LOAD_ESTUDIANTE_DETAILS_CURSO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.getEstudianteDetails(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los datos del estudiante proveniente, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_CURSO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CursoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_CURSO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del curso, inténtelo nuevamente"
            })
        }
    },

    ADD_CURSO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CursoService.post(payload)
            if (status === 201) {
                commit("ADD_CURSO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El curso ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el curso, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_CURSO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CursoService.put(payload)
            if (status === 200) {
                commit("UPDATE_CURSO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El curso ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el curso, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_CURSO: async ({ commit }, payload) => {
        try {
            let { status, data } = await CursoService.delete(payload)
            if (status === 204) {
                commit("DELETE_CURSO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El curso ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_CURSO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El curso ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el curso, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
